import {Label} from "./Label";
import {Client} from "./Client";
import {AutomationListTrigger} from "./AutomationListTrigger";
import {User} from "./User";
import {Deal} from "./Deal";
import {AutomationList} from "./AutomationList";
import {CustomProduct} from "./CustomProduct";
import {AutomationListFilter} from "./AutomationListFilter";

export class Recurrence {
    constructor({
                    //attributes
                    id= null,
                    category_id= null,
                    company_id= null,
                    name= '',
                    size= 0,
                    sales_total_value= 0,
                    sales_count= 0,
                    frequency= 0,
                    frequency_unit= 0,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                    filters= [],
                    automation_list= [],
                    category=null,
                    custom_products=[],
                } = {}) {

        //fill attributes
        this.id=id;
        this.category_id=category_id;
        this.company_id=company_id;
        this.name=name;
        this.size=size;
        this.sales_total_value=sales_total_value;
        this.sales_count=sales_count;
        this.frequency=frequency;
        this.frequency_unit=frequency_unit;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

        this.category = new Label(category||{});
        this.automation_list = new AutomationList(automation_list||{});
        this.custom_products = (custom_products||[]).map(c=>new CustomProduct(c));
        this.filters = (filters||[]).map(f=>new AutomationListFilter(f))
    }

}

export function createRecurrence(data={}) {
    return Object.freeze(new Recurrence(data));
}